import { render, staticRenderFns } from "./ResultBadge.vue?vue&type=template&id=6b485bfe&scoped=true&"
import script from "./ResultBadge.vue?vue&type=script&lang=js&"
export * from "./ResultBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b485bfe",
  null
  
)

export default component.exports